import { isPlainObject } from 'lodash';

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: {},
  fetchError: null,
  isPosting: false,
  completionStatus: {
    isFetching: false,
    hasFetched: false,
    data: {}
  },
  countryStatus: {
    isFetching: false,
    hasFetched: false,
    data: {}
  }
};

export default function space (state = initialState, action) {
  const { data, fetchError, type, completionStatusData, countryStatus } = action;

  if ('SPACE_CLEAR_STORE' === type) {
    return { ...initialState };
  }

  if ('SPACE_FETCH_REQUEST' === type) {
    return { ...state, isFetching: true };
  }

  if ('SPACE_FETCH_SUCCESS' === type) {
    return {
      ...state,
      data,
      hasFetched: true,
      isFetching: false
    };
  }

  if ('SPACE_UPDATE_FAQ_SUCCESS' === type) {
    const eventFaq = { ...state.data?.event_details };
    const dataKeys = Object.keys(data) || [];
    const deletedProp = 1 === dataKeys.length && data[dataKeys[0]]?.deleted ? dataKeys[0] : false;
    if (deletedProp) {
      delete eventFaq[deletedProp];
    } else if (isPlainObject(eventFaq[dataKeys[0]])) {
      eventFaq[dataKeys[0]] = { ...eventFaq[dataKeys[0]], ...data[dataKeys[0]] };
    } else {
      Object.assign(eventFaq, data);
    }
    return {
      ...state,
      data: { ...state.data, event_details: eventFaq }
    };
  }

  if ('SPACE_FETCH_FAQ_SUCCESS' === type) {
    const eventFaq = state.data.event_details || {};
    return {
      ...state,
      data: { ...state.data, event_details: { ...eventFaq, ...data } },
      hasFetched: true,
      isFetching: false
    };
  }

  if ('SPACE_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  if ('SPACE_COMPLETION_STATUS_FEFETCH_REQUEST' === type) {
    return {
      ...state,
      completionStatus: {
        isFetching: true
      }
    };
  }

  if ('SPACE_COMPLETION_STATUS_FETCH_SUCCESS' === type) {
    return {
      ...state,
      completionStatus: {
        hasFetched: true,
        isFetching: false,
        data: completionStatusData
      }
    };
  }

  if ('SPACE_COMPLETION_STATUS_FETCH_FAILURE' === type) {
    return {
      ...state,
      fetchError,
      completionStatusData: {
        hasFetched: true,
        isFetching: false
      }
    };
  }

  if ('SPACE_COUNTRY_STATUS_FEFETCH_REQUEST' === type) {
    return {
      ...state,
      countryStatus: {
        isFetching: true
      }
    };
  }

  if ('SPACE_COUNTRY_STATUS_FETCH_SUCCESS' === type) {
    return {
      ...state,
      countryStatus: {
        hasFetched: true,
        isFetching: false,
        data: countryStatus
      }
    };
  }

  if ('SPACE_COUNTRY_STATUS_FETCH_FAILURE' === type) {
    return {
      ...state,
      fetchError,
      countryStatus: {
        hasFetched: true,
        isFetching: false
      }
    };
  }

  if ('SPACE_UPDATE_REQUEST' === type) {
    return { ...state, isPosting: true };
  }

  if ('SPACE_UPDATE_SUCCESS' === type) {
    return { ...state, data, isPosting: false };
  }

  if ('SPACE_FAQ_UPDATE_SUCCESS' === type) {
    return { ...state, data, isPosting: false };
  }

  if ('SPACE_UPDATE_FAILURE' === type) {
    return { ...state, fetchError, isPosting: false };
  }

  if ('SPACE_CREATE_REQUEST' === type) {
    return { ...state, isPosting: true };
  }

  if ('SPACE_CREATE_SUCCESS' === type) {
    return { ...state, data, isPosting: false };
  }

  if ('SPACE_CREATE_FAILURE' === type) {
    return { ...state, fetchError, isPosting: false };
  }

  return state;
}
